import React from 'react'
import { Link } from 'react-router-dom'

import { ChevronRight, Home } from 'lucide-react'

import { cn } from '@/utils/cn'

export interface BreadcrumbsProps {
  items: Array<{ label: string; href?: string }>
}

export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  if (items.length === 0) {
    return null
  }

  return (
    <nav className="flex items-center space-x-1 text-sm" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-1">
        {items.map((item, index) => (
          <li key={index} className="flex items-center">
            {index > 0 && <ChevronRight className="h-4 w-4 text-gray-400 mx-2" />}
            {item.href ? (
              <Link
                to={item.href}
                className={cn(
                  'flex items-center space-x-1 text-gray-500 hover:text-gray-700 transition-colors',
                  'truncate max-w-[200px] sm:max-w-none'
                )}
              >
                {index === 0 && <Home className="h-4 w-4" />}
                <span className="hidden sm:inline">{item.label}</span>
                {index === 0 && <span className="sm:hidden">Inicio</span>}
              </Link>
            ) : (
              <span
                className={cn(
                  'flex items-center space-x-1 text-gray-900 font-medium',
                  'truncate max-w-[200px] sm:max-w-none'
                )}
              >
                {index === 0 && <Home className="h-4 w-4" />}
                <span className="hidden sm:inline">{item.label}</span>
                {index === 0 && <span className="sm:hidden">Inicio</span>}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}

export default Breadcrumbs
